import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'

import { resolveMobileBrowsePageTitle } from '@/config/mobilePageTitles'
import { useTranslation } from '@/features/locale/LocaleProvider'

type MobileBrowseTitleContextValue = {
  title: string
  setTitleOverride: (title: string | null) => void
}

const MobileBrowseTitleContext = createContext<MobileBrowseTitleContextValue | null>(null)

export function MobileBrowseTitleProvider({
  pathname,
  children,
}: {
  pathname: string
  children: React.ReactNode
}) {
  const [override, setOverride] = useState<string | null>(null)
  const t = useTranslation()

  useEffect(() => {
    setOverride(null)
  }, [pathname])

  const title = override ?? resolveMobileBrowsePageTitle(pathname, t.pageTitles).title

  const value = useMemo(
    () => ({
      title,
      setTitleOverride: setOverride,
    }),
    [title],
  )

  return <MobileBrowseTitleContext.Provider value={value}>{children}</MobileBrowseTitleContext.Provider>
}

export function useMobileBrowseTitleContext() {
  const context = useContext(MobileBrowseTitleContext)
  if (!context) {
    throw new Error('useMobileBrowseTitleContext must be used within MobileBrowseTitleProvider')
  }
  return context
}

/** Permite a interiores dinámicos (token, pool, tabs) sustituir el título de cabecera. */
export function useMobileBrowseTitleOverride(title: string | null | undefined) {
  const { setTitleOverride } = useMobileBrowseTitleContext()

  useEffect(() => {
    setTitleOverride(title ?? null)
    return () => setTitleOverride(null)
  }, [title, setTitleOverride])
}
